import React from "react";
import { createRoot } from "react-dom/client";
import InstagramCaptionGenerator from "../components/free-tools/InstagramCaptionGenerator";
import ToastProvider from "../components/shared/ToastProvider";

document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("instagram-caption-generator-main");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <>
        <ToastProvider />
        <InstagramCaptionGenerator />
      </>
    );
  }
});
